export default "__VITE_ASSET__9f5dc53b__"